import { useEffect } from 'react'
import { loadStart, loadSuccess, loadError } from '../reducer'

// fetch wrapper: resolves the parsed JSON body on 2xx; rejects with an Error
// carrying the HTTP status so the caller can build a status-aware message.
// Aborted requests reject with an AbortError the caller ignores. Private to this
// hook — the module has no other caller.
const apiFetch = (url, options = {}) =>
  fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' }, ...options })
    .then((r) => (r.ok ? r.json() : Promise.reject(Object.assign(new Error(), { status: r.status }))))

// Loads the summary once per URL. Data-fetching effect kept out of the component
// with a cancellation guard so a stale/aborted response can't overwrite fresh
// state (REACT-089). buildErrorMessage turns the rejection into a display string.
const useLoadSummary = (url, dispatch, buildErrorMessage) => {
  useEffect(() => {
    const controller = new AbortController()
    loadStart(dispatch)

    apiFetch(url, { signal: controller.signal })
      .then((summary) => loadSuccess(dispatch, summary))
      .catch((e) => {
        if (e.name === 'AbortError') return
        loadError(dispatch, buildErrorMessage(e))
      })

    return () => controller.abort()
  }, [url])
}

export default useLoadSummary
